import { Client as NetlifyClient } from "../../internal-api/netlify"
import { dialCodes } from "../../constants/countries"
import {
  ValidationError,
  ValidationErrorTypes,
} from "../errors/validation.error"
import { isEmail } from "../../helpers/validators"

export class AddressValidator {
  private netlifyClient = new NetlifyClient(process.env.GATSBY_SITE_URL!)

  public async isVatMember(
    vatNumber: string,
    countryCode: string,
    currentMarketUS: boolean
  ): Promise<boolean> {
    if (!vatNumber) {
      throw new ValidationError(
        "Please provide your TAX ID.",
        ValidationErrorTypes.VALUE_DOES_NOT_PROVIDED
      )
    }

    if (currentMarketUS) {
      return true
    } else if (countryCode === "PL" && vatNumber.length === 10) {
      return true
    }

    if (!countryCode) {
      throw new ValidationError(
        "Please provide a country to validate your TAX ID.",
        ValidationErrorTypes.VALUE_DOES_NOT_PROVIDED
      )
    }

    try {
      await this.netlifyClient.vat.isVatMember({ countryCode, vatNumber })
      return true
    } catch (error) {
      throw new ValidationError(
        "Please enter a valid TAX ID or use individual form.",
        ValidationErrorTypes.IS_NOT_VAT_MEMBER
      )
    }
  }

  public isPhoneNumber(phoneNumber: string): boolean {
    if (!phoneNumber) {
      throw new ValidationError(
        "Please provide a phone number.",
        ValidationErrorTypes.VALUE_DOES_NOT_PROVIDED
      )
    }
    if (!this.startsWithDialCode(phoneNumber)) {
      throw new ValidationError(
        "Please add a dial code of a phone number.",
        ValidationErrorTypes.INVALID_PHONE_NUMBER
      )
    }
    if (!this.isPhoneNumberValid(phoneNumber)) {
      throw new ValidationError(
        "Phone number is invalid.",
        ValidationErrorTypes.INVALID_PHONE_NUMBER
      )
    }
    return true
  }

  public isValidEmail(email: string): boolean {
    if (!email) {
      throw new ValidationError(
        "Please provide an email address.",
        ValidationErrorTypes.VALUE_DOES_NOT_PROVIDED
      )
    }
    if (!isEmail(email)) {
      throw new ValidationError(
        "Please enter a valid e-mail.",
        ValidationErrorTypes.INVALID_EMAIL
      )
    }
    return true
  }

  private startsWithDialCode(value: string) {
    return dialCodes.find((item) => value.startsWith(item.value))
  }

  private isPhoneNumberValid(value: string) {
    const code = this.startsWithDialCode(value)
    // 5 is a minimum length of a phone number for the whole world
    const properLength = code
      ? value.replace(" ", "").length >= code.value.length + 5
      : false
    return properLength && this.numbersOnly(value)
  }

  /* numbers with spaces and + */
  private numbersOnly(value: string) {
    return /^\+[\d\s]+$/.test(value)
  }
}
